module.exports = __webpack_public_path__ + "img/exitCssFull.c97d3118.svg";